import { Capacitor } from '@capacitor/core';

/**
 * Initialize native platform features.
 * Call once on app startup.
 */
export async function initNativePlatform() {
  if (!Capacitor.isNativePlatform()) return;

  // Status bar
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#1a1a1a' });
    }
  } catch {
    // Plugin not available
  }

  // Splash screen — auto-hide after content loads
  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide();
  } catch {
    // Plugin not available
  }

  // Android back button handling
  if (Capacitor.getPlatform() === 'android') {
    try {
      const { App } = await import('@capacitor/app');
      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.minimizeApp();
        }
      });
    } catch {
      // Plugin not available
    }
  }
}

/**
 * Trigger haptic feedback. Silently fails on web.
 */
export async function hapticFeedback(type: 'light' | 'medium' | 'heavy' = 'medium') {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    const style = type === 'light' ? ImpactStyle.Light : type === 'heavy' ? ImpactStyle.Heavy : ImpactStyle.Medium;
    await Haptics.impact({ style });
  } catch {
    // Haptics not available
  }
}

/**
 * Trigger success haptic (notification style).
 */
export async function hapticSuccess() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    // Haptics not available
  }
}
